import React, { useState, useEffect, useCallback, useRef } from 'react';

const secondInMS = 1000;
const minuteInMS = 60 * secondInMS;
const hourInMS = 60 * minuteInMS;
const dayInMS = 24 * hourInMS;

const Timer = ({ timerStartTime, endTime, startTime, customStyles }) => {
  const [time, setTime] = useState('');
  const timerRef = useRef(null);
  const setTimer = useCallback(() => {
    let hours = 0;
    let minutes = 0;
    let seconds = 0;
    let days = 0;
    const currentTime = Date.now();
    if (currentTime >= +timerStartTime) {
      let remainingTime = 0;
      if (+timerStartTime < +startTime) {
        remainingTime = +startTime - +timerStartTime;
      } else if (+timerStartTime < +endTime) {
        remainingTime = +endTime - +currentTime;
      }

      if (remainingTime > 0) {
        days = Math.floor(remainingTime / dayInMS);
        remainingTime %= dayInMS;
        hours = Math.floor(remainingTime / hourInMS);
        remainingTime %= hourInMS;
        minutes = Math.floor(remainingTime / minuteInMS);
        remainingTime %= minuteInMS;
        seconds = Math.floor(remainingTime / secondInMS);

        let timerString = '';
        let timeInterval = 1000;
        if (days) {
          const dayString = `${days > 9 ? days : `0${days}`}d`;
          const hourString = `${hours > 9 ? hours : `0${hours}`}h`;
          const minuteString = `${minutes > 9 ? minutes : `0${minutes}`}m`;

          timerString = `${dayString} : ${hourString} : ${minuteString}`;
          timeInterval =
            seconds === 0 ? minuteInMS + secondInMS : seconds * secondInMS + secondInMS;
        } else {
          const hourString = `${hours > 9 ? hours : `0${hours}`}h`;
          const minuteString = `${minutes > 9 ? minutes : `0${minutes}`}m`;
          const secondString = `${seconds > 9 ? seconds : `0${seconds}`}s`;

          timerString = `${hourString} : ${minuteString} : ${secondString}`;
        }

        setTime(timerString);
        timerRef.current = setTimeout(setTimer, timeInterval);
      }
    }
  }, [startTime, endTime, timerStartTime]);

  useEffect(() => {
    setTimer();

    return () => {
      clearTimeout(timerRef.current);
    };
  }, [setTimer]);

  return time ? (
    <span style={customStyles} className="timerTextStyle">
      {time}
    </span>
  ) : null;
};

export default Timer;
